site.SellsWithKit = site.SellsWithKit || {};

(function ($) {
  pcgProductImageTitleV1 = {
    formatter: $('.pcg-product-image-title-v1')
  };

  Drupal.behaviors.pcgProductImageTitle = {
    get: function (key) {
      return pcgProductImageTitleV1[key];
    },

    set: function (key, val) {
      pcgProductImageTitleV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // quickview slide down
        thisFormatter.find('.btn-quickview').once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();
          var $thisElem = $(this);
          var prodId = $(this).closest('.product').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p.PRODUCT_ID === prodId;
            })[0];
            var $qs = site.quickshop.render({
              productData: product
            });

            $('.caret').filter(':not(.hidden)').addClass('hidden');
            // close any other open qs
            $('#quickshop').slideUp('0', function () {
              $(this).remove();
            });

            var clickedProduct = $(this).closest('.product');
            var bottom_padding = 50;
            var speed = 500;
            var topPositionNavOffset = $('#top').height() + 40;

            // append after row
            $qs.insertAfter($(this).closest('.row')).addClass('pcg-product-carousel');
            $qs.delay(100).slideDown(speed, function () {
              if ($(this).is('#quickshop')) {
                $(document).trigger('sells_with_init', $qs);
              }
              var $windowObj = $(window);
              var pos = $qs.position();
              var window_height = $windowObj.height();
              var offset = $qs.offset();
              var posY = offset.top - $windowObj.scrollTop();
              var clickedProductOffset = clickedProduct.offset();
              var clickedProductY = clickedProductOffset.top - $windowObj.scrollTop();
              var qs_bottom_position = posY + $('#quickshop').height() + bottom_padding;

              // only scroll page if the quickshop fall within the viewable area
              if (qs_bottom_position > window_height) {
                /**
                 * bottom of quickshop isn't visible, so let's formulate both options
                **/
                // option 1: place selected product near top of viewing area
                var prod_row = (clickedProductY - topPositionNavOffset) + $windowObj.scrollTop();
                // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
                var quickshop_in_viewport = (qs_bottom_position - window_height) + $windowObj.scrollTop();
                // select our best option
                var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

                // now scroll the window...
                $('body, html').scrollTo(scrollPosition, {
                  duration: speed,
                  axis: 'y'
                });
              }
            });

            // override close to remove dom node
            $qs.find('.close').off('click').on('click', function() {
              $qs.slideUp('500', function () {
                $qs.remove();
                $thisElem.closest('.grid-content, ul.slides').find('div[data-productid="' + product.PRODUCT_ID + '"] .caret').addClass('hidden');
              });
            });
            // show caret
            $thisElem.closest('.grid-content, ul.slides').find('div[data-productid="' + product.PRODUCT_ID + '"] .caret').removeClass('hidden');
          }
        });
      });
    }
  };
})(jQuery);
